import { React, useEffect, useState } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { useLocation, useNavigate } from "react-router-dom";
import { getBaseUrl } from "../utils";
import axios from "axios";

const BlogDeatils = () => {

    const [singleblog, setsingleblog] = useState([]);
    const [b_data, setBlogData] = useState([]);

    const navigate = useNavigate();
    const location = useLocation();

    if (!location.state) {
        navigate("/");
    }

    const blogData_1 = async () => {
        try {
            const response = await axios.get(`${getBaseUrl()}user_api/blogData`);
            if (response.data && response.data.results) {
                setBlogData(response.data.results);
            }
        } catch (error) {
            console.error("Error fetching Blog Data:", error);
        }
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        blogData_1();

        const blogData = location.state?.blogData;
        if (blogData) {
            setsingleblog(blogData);
        } else {
            console.warn("Blog data not found, redirecting...");
        }
    }, [location]);

    const handleTabClick = (blogData) => {
        navigate('/BlogDeatils', { state: { blogData: blogData } });
    };

    // Filter out singleblog from b_data
    const filteredBlogData = b_data.filter((item) => item.name !== singleblog.name);

    return (
        <div>
            <Navbar />
            <section className="pt-[50px] bg-[#F2F2F2] pb-[80px] mt-20 md:px-0 px-2">
                <div className="container-xxl">
                    <div className="row">
                        <div className="headeing pb-4">
                            {/* <h1 className="Header__text font-[700]" style={{ fontSize: '28px' }}>
                                How to Create a Study Schedule That Works for you.
                            </h1> */}
                        </div>
                        <div className="col-md-12 pl-0 m-0 ">
                            <img
                                src={singleblog ? singleblog.image : ""}
                                alt="images"
                                className="w-full rounded-lg"
                            />
                            <h4 className="font-[700] pt-4 pb-1" style={{ fontSize: '28px' }}>
                                {singleblog ? singleblog.name : ""}
                            </h4>
                            <div className="no-tailwind">
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: singleblog ? singleblog.description : "",
                                    }}
                                />
                            </div>

                        </div>
                        {/* <div className="col-md-4">
                            <div className="flex items-center pr-0 m-0 ">
                                <div className="w-[44%]">
                                    <h2 className="Paragraph__etxt font-[700]">
                                        More Blogs
                                    </h2>
                                </div>
                                <div className="bg-[#414141] w-full h-[3px]" />
                            </div>
                            {filteredBlogData.map((items, index) => (
                                <div className="rounded-[15px]" key={index}>
                                    <div className="pb-8 pt-8">
                                        <div className="images">
                                            <img
                                                src={items.image}
                                                alt="images"
                                                className='rounded-lg'
                                            />
                                        </div>
                                        <div className="text">
                                            <h4
                                                className="Header__text font-[700] pt-[15px] pb-[5px]"
                                                style={{ fontSize: "18px" }}
                                            >
                                                {items.name}
                                            </h4>
                                            <div className="Paragraph__etxt pb-6 pb-[15px]">
                                                <div
                                                    dangerouslySetInnerHTML={{
                                                        __html: items.description.slice(0, 100) + "...",
                                                    }}
                                                />
                                            </div>
                                            <label
                                                onClick={() => handleTabClick(items)}
                                                className="Header__text font-[700] flex itemns-center"
                                                style={{ fontSize: "18px" }}
                                            >
                                                Read More<i className="ri-arrow-right-line"></i>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div> */}
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    );
};

export default BlogDeatils;
